<template>
    <v-card class="bg-card mb-2">
        <v-card-text class="px-0 pt-0 pb-0">

            <LocalTable :model="model" modelLinesProp='invoices' not-editable no-hover dense :dt="tblLines">
                
                <template v-slot:menu ="{ item }">
                    <ActionMenuItem icon="edit" :model="model" action="salesinvoice.open" @click="()=>onOpenInvoice(item)">Open factuur</ActionMenuItem>
                </template>

                <template v-slot:item.inv_status ="{ item }">
                    <span class="cursor-pointer" @click="()=>onOpenInvoice(item)">            
                        <StatusChip type="salesinvoice" :status="item.inv_status" :substatus="invoiceUtils.subStatus(item)">{{invoiceUtils.statusRep(item)}}</StatusChip>
                    </span>
                </template>
                
                <template v-slot:bottom-commands="{/*dt, hasCmd, */columnHeaders}">
                    <v-divider></v-divider>
                    <div class="pa-4 pb-2">
                        <ActionButton sub action="workorder.modify" dusk="btn-add-invoice" :model="model" icon="add" @click='(evt)=>onStartCreateInvoice(evt)'>Factuurvoorstel</ActionButton>
                    </div>
                </template>

            </LocalTable>
        </v-card-text>

    </v-card>
</template>



<script setup>

import ActionButton from '@shared/ui/controls/buttons/ActionButton'
import LocalTable from '@datatable/LocalTable'  
import clsLocalTable from '@cls/clsLocalTable'
import ActionMenuItem from "@controls/menu/ActionMenuItem.vue";
import {ref} from 'vue'
import dlg from '@app/dlg'
import {invoiceUtils} from '@/app/utils'
import StatusChip from "@controls/widgets/StatusChip.vue";

const props = defineProps({
    model: {
        type: [Object]
    },
});
const emit = defineEmits(['onCreateInvoice', 'save'])

let headers = [

    { type: 'cmd'},
        { type: 'note', noteType: 'salesinvoice_note'},
        { text: "Status",                   value: "inv_status", },
        { text: "Factuurnummer",            value: "inv_number", type: 'open', fmt: (v, item) => ((v)? v : '-')} ,
        { visible: false, text: "Klant",                    value: "rel_name"} ,
        {  text: "Factuur titel",            value: "inv_name",       cellClass: "max-col-width" },
        { visible: false, text: "Referentie",               value: "inv_reference", fmt: (v, item) => ((v)? v : '-')} ,
        { text: "Factuurdatum",             value: "inv_date",    type: 'date', sort: 'desc'   },
        { visible: false, text: "Vervaldatum", value: "inv_exp_date", type: 'date'},
        { footer: 'amount', text: "Excl BTW",                 value: "inv_sub_total",     type: 'amount'     },
        { footer: 'amount', text: "BTW",                      value: "inv_vat_total",      type: 'amount'     },
        { footer: 'amount', text: "Incl BTW",                 value: "inv_total",  type: 'amount'     },
        { visible: false,  text: "Betaald",                  value: "inv_total_paid",     type: 'amount'     },
        { visible: false,  text: "Openstaand",               value: "inv_amount_open",     type: 'amount'     },
        { visible: false,  text: "1e herinnering",           value: "reminder1_date",     type: 'date'     , emptyText: '-'},
        { visible: false,  text: "2e herinnering",           value: "reminder2_date",     type: 'date'     , emptyText: '-'},
        { visible: false,  text: "In gebrekestelling",       value: "defaultnotice_date",     type: 'date' , emptyText: '-'},

        { isUtc: true, visible: false, text: "Gewijzigd",                value: "updated_at",    type: 'datetime',   },
		{ visible: false, text: "Gewijzigd door",           value: "updated_by",                        },
		{ isUtc: true, visible: false, text: "Aangemaakt",               value: "created_at",    type: 'datetime',   },
		{ visible: false, text: "Aangemaakt door",          value: "created_by",                        },
];



let tblLines = ref(new clsLocalTable("workorder.invoices", headers, {
    noDataText: "Er is nog geen factuur gemaakt",
    noSort: true,
    model: props.model, 
    modelLinesProp: 'invoices',
    showFooter: true,   
}));

async function onStartCreateInvoice() {
        var fnCreateInvoice = async (dlgModel) => {
            var id_invoice = await props.model.createInvoice(dlgModel); 
            dlgModel.close();
            dlg.open('salesinvoice', {id: id_invoice});
        }
        var dlgCreateInvoice = await dlg.open('workorder_createinvoice', {id: props.model.id});
        dlgCreateInvoice.hookSaved(fnCreateInvoice);
}

// Open the invoice
async function onOpenInvoice(item) {
    //dlg.open('salesinvoice', item);
    var invResult = await dlg.promised.tryOpen('salesinvoice', item);
    console.log(invResult);
}

</script>